import script from "./ContactFormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactFormComponent.vue?vue&type=script&setup=true&lang=js"

import "./ContactFormComponent.vue?vue&type=style&index=0&id=0788d4b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0788d4b6"]])

export default __exports__